import React from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import ServiceTitlePres from './ServiceTitlePres';
import DropdownNew from 'src/ui/library/DropdownNew';

export default function ChooseInitiationPres({
  engagement,
  engagementList,
  country,
  countryList,
  serviceType,
  serviceTypeList,
  initiationType,
  initiationTypeList,
  isServiceTypeVisible,
  updateValue,
  onInitiationChange,
  isCorpClient,
}) {
  return (
    <React.Fragment>
      <ServiceTitlePres title={intl.get('serviceInit.addInit.choose.title')} />
      {/* <span className="ssi-add-text">{intl.get('serviceInit.addInit.choose.addText')}</span> */}
      <div className="ssi-choices">
        <div className={'ssi-addapplicant-grid'}>
          {!isCorpClient && (
            <DropdownNew
              id="engagement"
              name="engagement"
              label={intl.get('serviceInit.addInit.choose.engagement')}
              options={engagementList && engagementList.map((item, index) => ({ value: item.engagementId, label: item.engagementName }))}
              className={'ssi-dropdown'}
              disableUnderline={true}
              required={true}
              value={engagement !== -1 ? engagement : ''}
              onChange={event => updateValue('engagement', event.target.value)}
            />
          )}

          {/* Please dont remove below code, its just a noraml fix for defect/63864 */}
          {/* <DropdownNew
            id="initiationType"
            name="initiationType"
            label={intl.get('serviceInit.addInit.choose.initiationType')}
            options={initiationTypeList.map((item, index) => ({ value: item.initiationId, label: item.initiationType }))}
            className={'ssi-dropdown'}
            disableUnderline={true}
            required={true}
            value={initiationType !== -1 ? initiationType : ''}
            onChange={event => onInitiationChange(event.target.value)}
          /> */}

          {isServiceTypeVisible && (
            <DropdownNew
              id="serviceType"
              name="serviceType"
              label={intl.get('serviceInit.addInit.choose.serviceType')}
              options={serviceTypeList && serviceTypeList.map((item, index) => ({ value: item.serviceTypeAb, label: item.serviceType }))}
              className={'ssi-dropdown'}
              disableUnderline={true}
              required={true}
              value={serviceType}
              onChange={event => updateValue('serviceType', event.target.value)}
            />
          )}
          {!!serviceType && isServiceTypeVisible && (
            <DropdownNew
              id="country"
              name="country"
              label={intl.get('serviceInit.addInit.choose.serviceCountry')}
              options={countryList && countryList.map((item, index) => ({ value: item.countryCode, label: item.countryName }))}
              className={'ssi-dropdown'}
              disableUnderline={true}
              required={true}
              virtualized={true}
              value={country}
              onChange={event => updateValue('country', event.target.value)}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

ChooseInitiationPres.propTypes = {
  engagement: PropTypes.number,
  engagementList: PropTypes.array,
  country: PropTypes.string,
  countryList: PropTypes.array,
  serviceType: PropTypes.string,
  serviceTypeList: PropTypes.array,
  initiationType: PropTypes.number,
  initiationTypeList: PropTypes.array,
  isServiceTypeVisible: PropTypes.bool,
  updateValue: PropTypes.func.isRequired,
  onInitiationChange: PropTypes.func.isRequired,
};
